<template>
  <div class="page border-box" v-wechat-title="$route.meta.title">
    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
        <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
          <div class="video-box" v-if="item.isvideo">
            <img class="icon-bf" src="../../assets/icon-bf.png" alt="" v-if="item.isvideo&&!isplay"  @click="playVideo()">
            <img :src="item.imgurl" class="video-bg" v-if="item.isvideo&&!isplay">
            <video :src="item.video" controls @play="videoPlay" preload="meta" :poster="item.imgurl" @pause="videoPause"  id="videoPlay" v-show="item.isvideo&&isplay"></video>
          </div>
          <img class="img" :src="item.imgurl"  @click="toLink(item.link)" width="100%" height="100%" alt="" v-if="!item.isvideo && item.link">
          <img class="img" :src="item.imgurl"  @click="seeImg(item.imgurl,banners)" width="100%" height="100%" alt="" v-if="!item.isvideo && !item.link">
        </div>
      </swiper>
      <div class="swiper-len" v-if="banners&&banners.length>1"><span>{{swiperCurr>banners.length?'1':swiperCurr+1}}</span>/{{banners.length}}</div>
    </div>

    <div class="desc-box border-box">
      <div class="time-box" v-if="(vip_product&&vip_product.children.length>0) || (pin_product&&pin_product.children.length>0)">
        <div class="title clearfix">
          <div class="fl tit-line"><b></b><span>讲解时段</span></div>
        </div>
        <p class="time-name" style="padding-top: .1rem;" v-if="vip_product&&vip_product.children.length>0">VIP团</p>
        <div class="time-con border-box" v-if="vip_product&&vip_product.children.length>0">
          <div class="time-list box" v-if="vip_product.am&&vip_product.am.length>0">
            <div class="l">上午场</div>
            <div class="flex r clearfix">
              <div class="fl time-item" v-for="(item,index) in vip_product.am" :key="index">
                <span>{{item.stime}}</span><img src="../../assets/line.png" alt=""><span>{{item.etime}}</span>
              </div>
            </div>
          </div>
          <div class="time-list box" v-if="vip_product.pm&&vip_product.pm.length>0">
            <div class="l">下午场</div>
            <div class="flex r clearfix">
              <div class="fl time-item" v-for="(item,index) in vip_product.pm" :key="index">
                <span>{{item.stime}}</span><img src="../../assets/line.png" alt=""><span>{{item.etime}}</span>
              </div>
            </div>
          </div>
        </div>

        <p class="time-name" style="padding-top: .1rem;" v-if="pin_product&&pin_product.children.length>0">拼团</p>
        <div class="time-con border-box" v-if="pin_product&&pin_product.children.length>0">
          <div class="time-list box" v-if="pin_product.am&&pin_product.am.length>0">
            <div class="l">上午场</div>
            <div class="flex r clearfix">
              <div class="fl time-item" v-for="(item,index) in pin_product.am" :key="index">
                <span>{{item.stime}}</span><img src="../../assets/line.png" alt=""><span>{{item.etime}}</span>
              </div>
            </div>
          </div>
          <div class="time-list box" v-if="pin_product.pm&&pin_product.pm.length>0">
            <div class="l">下午场</div>
            <div class="flex r clearfix">
              <div class="fl time-item" v-for="(item,index) in pin_product.pm" :key="index">
                <span>{{item.stime}}</span><img src="../../assets/line.png" alt=""><span>{{item.etime}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box" v-if="site&&site.length>0">
        <div class="title clearfix">
          <div class="fl tit-line">
            <b></b>
            <span>讲解内容</span>
          </div>
          <!--<div class="fl title-tip" v-if="site.length>1">-->
            <!--<img  class="fl" src="../../assets/tip03.png" alt="">-->
            <!--<span class="fl">以下为VIP精品线路，拼团线路由馆方安排</span>-->
          <!--</div>-->
        </div>
        <div class="route-list">
          <div class="item" v-for="(item,index) in site" :key="index">
            <p class="name">【{{item.name}}】<font v-if="item.label">- {{item.label}}</font></p>
            <div class="txt">
              {{item.title}}<span v-if="item.time">：讲解时间{{item.time}}</span><span v-if="item.children&&item.children.length>0">，线路包含{{item.children.length}}个游览点
              <font>(<i style="font-style: normal" v-for="(ite,ind) in item.children" :key="ite.name">{{ite.name}}{{ind<(item.children.length-1)?'、':''}}</i>）</font></span>
            </div>
            <div class="route-img clearfix" v-if="item.children&&item.children.length>0">
              <template v-for="(ite,ind) in item.children">
                <!--<img class="fl img" :src="ite.logo" alt="" v-for="(ite,ind) in item.children" :key="ite.logo">-->
                <img class="fl img" :src="it" alt="" v-for="(it,idd) in (ite.logo).split(',')" v-if="ite.logo">
              </template>

            </div>
          </div>
        </div>
      </div>

      <div class="know-box">
        <div class="title clearfix">
          <div class="fl tit-line"><b></b><span>预约须知</span></div>
        </div>

        <div class="info">
          <div style="font: .26rem/.48rem 'Microsoft YaHei';color: #333;" v-html="content"></div>
          <!--
          <p style="font: .26rem/.48rem 'Microsoft YaHei';color: #333;">
            【费用包含】价格默认包含精讲服务费，不含门票等费用，可在付款页面自选添加 <br>
            【儿童说明】6岁(含)以下儿童免讲解费，不占席位，不含耳机和保险，请家长务必自行看管好自己的小孩 <br>
            【人数说明】人数上限不包含免费携带的6岁以下免费儿童数量 <br>
            【诚信说明】大咖说会提前按照下单人数准备讲解老师，同行若有免费儿童或临时增加游玩人数,请务必如实填写，不诚信的超员我们有权拒绝入团 <br>
            【迟到说明】为减少同团客人等待时间，您需要准时前往集合点集合，若临时耽误可提前与讲解老师沟通。无故迟到>15分钟视为主动放弃当日行程，所有讲解费用无法退还
          </p>
          -->
        </div>

      </div>

      <div class="process-box">
        <div class="title clearfix">
          <div class="fl tit-line"><b></b><span>预约流程</span></div>
        </div>
        <div class="list">
          <div class="item box">
            <div class="l"><span class="dot"></span></div>
            <div class="flex r">
              <p class="tit">第一步</p>
              <div class="sub">预约付费成功</div>
            </div>
          </div>
          <div class="item box">
            <div class="l"><span class="dot"></span></div>
            <div class="flex r">
              <p class="tit">第二步</p>
              <div class="sub">等待讲解接单，安排讲解员</div>
            </div>
          </div>
          <div class="item box">
            <div class="l"><span class="dot"></span></div>
            <div class="flex r">
              <p class="tit">第三步</p>
              <div class="sub">收到预约成功通知，规划行程</div>
            </div>
          </div>
          <div class="item box">
            <div class="l"><span class="dot"></span></div>
            <div class="flex r">
              <p class="tit">第四步</p>
              <div class="sub">提前到达前台扫码签到</div>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="fixed-bottom border-box">
      <div class="fl item-l" @click="toOrder">
        <img src="../../assets/icon-dd.png" alt="">订单
      </div>
      <a class="fl item-l" :href="'tel:'+contact">
        <img src="../../assets/icon-kf.png" alt="">客服
      </a>
      <div class="fr btn-box">
        <div class="btn linear" @click="toHome">预约讲解</div>
      </div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import calendar from '../../components/calendar'
  import AlertOrderKnow from '../../components/AlertOrderKnow'
  import {getScenicCover} from "@/service/getData";
  import {wxImgPreview,wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      const self = this;
      return {
        userInfo: {}, //用户信息
        P400: 0, //系统维护中
        swiperCurr:0,
        swiperOption: {
          initialSlide: 0,
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: true,//开启循环模式
          autoplay: false,
          slidesPerView: 1,
          spaceBetween: 0,
          observeParents:true,
          observer: true,
          preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          on: {
            slideChangeTransitionEnd: function () {
              self.swiperCurr = this.activeIndex;
              // 切换结束时，告诉我现在是第几个slide
            }
          }
        },
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        banners: [], //景区banner图
        vip_product: '', //包团票
        pin_product: '', //拼团票
        site: '', //线路信息
        contact: '', //联系方式
        content: '', //预约须知
        isplay: 0, //视频是否在播放
      }
    },
    computed: {},
    created(){
//      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");

      this.getScenicCoverFun();




    },
    methods: {
      callback(a){ },

      //获取基本信息
      async getScenicCoverFun(){
        let res = await getScenicCover({
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          var data = res.data;
          this.banners = data.banner;
          this.content = data.content;
          this.contact = data.contact;
          console.log(this.contact)

          this.pin_product = data.pin_product;
          this.site = data.site;

          if(data.vip_product && data.vip_product.children && data.vip_product.children.length>0){
            var vChildren = data.vip_product.children;
            data.vip_product.am = []; //上午
            data.vip_product.pm = []; //下午
            for(var i=0; i<vChildren.length; i++){
              if(vChildren[i].stime && vChildren[i].stime.substring(0,2)>=12){ //大于12点
                data.vip_product.pm.push(vChildren[i]);
              }else {
                data.vip_product.am.push(vChildren[i]);
              }
            }
            this.vip_product = data.vip_product;
          }

          if(data.pin_product && data.pin_product.children && data.pin_product.children.length>0){
            var pChildren = data.pin_product.children;
            data.pin_product.am = []; //上午
            data.pin_product.pm = []; //下午
            for(var i=0; i<pChildren.length; i++){
              if(pChildren[i].stime && pChildren[i].stime.substring(0,2)>=12){ //大于12点
                data.pin_product.pm.push(pChildren[i]);
              }else {
                data.pin_product.am.push(pChildren[i]);
              }
            }
            this.pin_product = data.pin_product;
          }

          this.$route.meta.title = data.name;


          let title = data.name + ' | 预约讲解';
          let desc = '欢迎使用预约讲解服务系统';
          let link = '/cover?scenicId='+this.scenicId+'&scenicKey='+this.scenicKey;
          let img = (data.banner[0]&&data.banner[0].imgurl)?data.banner.imgurl:''
          wxShareme(title, desc, img, link);
        }else {
          this.$toast(res.errmsg);
        }
      },

      //跳转到预约页面
      toHome(){
        this.$router.push({
          path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey
        });
      },

      //跳转到订单页面
      toOrder(){
        this.$router.push({
          path: `/order-list?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey
        });
      },

      //banner图片预览
      seeImg: function(img,imgs){
        var arr = [];
        for(var i=0; i<imgs.length; i++){
          arr.push(imgs[i].imgurl);
        }
        wxImgPreview(img,arr);
      },

      //评论图片预览
      seeComImg:function(img,imgs){
        wxImgPreview(img,imgs);
      },

      //跳转链接
      toLink: function (url){
        window.location = url;
      },


      //点击播放按钮
      playVideo(){
        var Video = document.getElementById("videoPlay");
        if(Video.paused){
          Video.play();
          this.isplay = 1;
        }else {
          Video.pause();
          this.isplay = 0;
        }
      },
      //监听播放与暂停
      videoPlay(){
        this.isplay = 1;
      },
      videoPause(){
        this.isplay = 0;
      },



    },
    watch: {},
    components: {
        P400
    },
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  /** {touch-action: pan-y;touch-action: pan-x;}*/
  .page{width: 100vw;min-height: 100vh;background: #f6f7fb;overflow-y:scroll;}
  .btn{height:.56rem;font: .28rem/.56rem "Microsoft YaHei";border-radius: .28rem;text-align: center;}
  .btn-s{width: 1.32rem;}
  .btn-l{width: 1.54rem;}
  .swiper-box{position:relative;width: 100vw;height: 4.7rem;}
  .swiper-container{width: 100%;height: 100%;}
  .swiper-slide .video-box{position: absolute;top:0;left: 0;width: 100%;height: 100%;}
  .swiper-slide .video-bg{position: absolute;top:0;left: 0;z-index: 1;width: 100%;height: 100%;}
  .swiper-slide .icon-bf{position: absolute;top:50%;left: 50%;z-index: 2;width:.8rem;height: .8rem;margin:-.4rem 0 0 -.4rem; }

  .swiper-slide .img{width: 100%;height: 100%;object-fit: cover;}
  .swiper-slide video{width: 100%;height: 100%;object-fit: cover;}
  .swiper-len{position: absolute;right: .24rem;bottom:.4rem;z-index: 1;height: .44rem;padding:0 .22rem;font:.26rem/.44rem "Microsoft YaHei";color:#fff;background: rgba(0,0,0,.5);border-radius: .22rem;}


  .desc-box{position:relative;z-index:1;min-height: calc(100vh - 4.46rem);padding:.4rem .3rem 1.2rem;margin: -.24rem .24rem 0;border-radius: .2rem .2rem 0 0;background: #fff;}
  .time-box{padding-bottom: .4rem;border-bottom: 1px solid #e5e5e5;}
  .time-box .time-name{margin-top: .3rem;font: .28rem "Microsoft YaHei";color: #333;}
  .time-box .time-con{padding: .14rem;margin-top: .18rem;border-radius: .08rem;background: #fff9f3;}
  .time-box .time-list{line-height:.52rem;border-bottom: 1px solid #ebe5e0;}
  .time-box .time-list:last-child{border-bottom: none;}
  .time-box .time-list .l{width:1rem;font: .26rem/.52rem "Microsoft YaHei";color: #fa4f45;}
  .time-box .time-item{margin-right: .2rem;}
  .time-box .time-item:nth-of-type(2n){margin-right: 0;}
  .time-box .time-item span{float: left;font: .26rem/.52rem "Microsoft YaHei";color: #666;}
  .time-box .time-item img{float:left;width: auto;height: .1rem;margin: .21rem .1rem 0;}

  .content-box{margin-top: .4rem;padding-bottom: .4rem;border-bottom: 1px solid #e5e5e5;}
  .content-box .title-tip{font: .2rem/.32rem "Microsoft YaHei";color: #666;}
  .content-box .title-tip img{width: auto;height: .22rem;margin-top: .05rem;margin-left: .12rem;margin-right: .06rem;}
  .content-box .item{margin-top:.32rem;}
  .content-box .name{color: #fa544a;font: bold .28rem "Microsoft YaHei";}
  .content-box .txt{margin-top:.1rem;font: .24rem/.36rem "Microsoft YaHei";color: #333;}
  .content-box .route-img img{margin-top: .15rem;width: 49%;height: 1.96rem;margin-right:2%;border-radius: .12rem;overflow: hidden;}
  .content-box .route-img img:nth-of-type(2n){margin-right: 0;}

  .know-box{margin-top: .4rem;padding-bottom: .4rem;border-bottom: 1px solid #e5e5e5;}
  .know-box .info{margin-top: .24rem;}

  .process-box{margin-top: .4rem;}
  .process-box .list{position: relative;}
  .process-box .list:after{content:'';position: absolute;top:.36rem;left: .28rem;bottom:0;border-left: 1px dashed #dcdcdc;}

  .process-box .item{padding-top: .3rem;}
  .process-box .item .dot{position: relative;z-index: 1;display:block;width: .16rem;height: .16rem;margin-left: .2rem;margin-top: .08rem;margin-right:.3rem;border-radius: 50%;background: #faaf39;}
  .process-box .item .r{border-bottom: 1px solid #e5e5e5;padding-bottom: .3rem;}
  .process-box .item:last-child .r{border-bottom: none;}
  .process-box .item .tit{font: .28rem/.32rem  "Microsoft YaHei";color: #333;}
  .process-box .item .sub{margin-top:.1rem;font: .26rem/.36rem "Microsoft YaHei";color: #666;}

  .fixed-bottom{position: fixed;left: 0;bottom:0;z-index:9;width: 100%;height: .98rem;padding: 0 .3rem;background: #fff;border-top:1px solid #e3e3e3;}
  .fixed-bottom .item-l{height: .92rem;font: .28rem/.92rem "Microsoft YaHei";color: #333;}
  .fixed-bottom .item-l:first-child{margin-right: .48rem;}
  .fixed-bottom .item-l img{float: left;width: auto;height: .32rem;margin-top: .3rem;margin-right: .08rem;}
  .fixed-bottom .btn-box{width: 48vw;height: .72rem;margin-top: .13rem;color:#fff;text-align:center;border-radius: .36rem;overflow: hidden;}
  .fixed-bottom .btn{float: left;width: 100%;height: 100%;font:.32rem/.72rem "Microsoft YaHei";border-radius: 0;}
  .fixed-bottom .btn.disabled{ background: #e3e3e3;border: none;}
</style>



// WEBPACK FOOTER //
// src/page/home/cover.vue